<template>
    <!--
      	作者：bbc_team
      	时间：2023-06-08
      	描述：插件中心-优惠券-优惠券列表-添加优惠券
      -->
    <div class="goods-add">
        <!--form表单-->
        <el-form ref="form" size="small" :model="form" :rules="rules" label-width="200px">
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="基本信息" name="1"></el-tab-pane>
                <el-tab-pane label="适用商品" name="2"></el-tab-pane>
            </el-tabs>
            <template v-if="activeName == '1'">
                <!--添加门店-->
                <div class="common-form">添加优惠券</div>
                <el-form-item label="优惠券名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入优惠券名称"></el-input>
                    <div class="tips">例如：满100减10</div>
                </el-form-item>
                <el-form-item label="优惠券颜色">
                    <el-radio-group v-model="form.color">
                        <el-radio :label="10">蓝色</el-radio>
                        <el-radio :label="20">红色</el-radio>
                        <el-radio :label="30">紫色</el-radio>
                        <el-radio :label="40">黄色</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="优惠券类型">
                    <el-radio-group v-model="form.coupon_type">
                        <el-radio :label="10">满减券</el-radio>
                        <el-radio :label="20">折扣券</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="减免金额" prop="reduce_price" v-show="form.coupon_type == 10">
                        <el-input v-model="form.reduce_price" placeholder="请输入减免金额" type="number"></el-input>
                    </el-form-item>
                <el-form-item label="折扣率" v-show="form.coupon_type!==10">
                        <el-input v-model="form.discount" placeholder="请输入折扣率" type="number"></el-input>
                        <div class="tips">折扣率范围0-10，9.5代表9.5折，整数或1位小数</div>
                    </el-form-item>

                <el-form-item label="最低消费金额" prop="min_price">
                    <el-input v-model="form.min_price" placeholder="请输入最低消费金额" type="number"></el-input>
                </el-form-item>
                <el-form-item label="到期类型">
                    <el-radio-group v-model="form.expire_type">
                        <el-radio :label="10">领取后生效</el-radio>
                        <el-radio :label="20">固定时间</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="form.expire_type == 10">
                    <el-form-item label="有效天数">
                        <el-input v-model="form.expire_day" placeholder="请输入有效天数" type="number"></el-input>
                    </el-form-item>
                </div>
                <div v-else>
                    <el-form-item label="有效时间">
                        <el-date-picker
                            v-model="form.active_time"
                            type="daterange"
                            align="right"
                            unlink-panels
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions0"
                        ></el-date-picker>
                    </el-form-item>
                </div>
                <el-form-item label="发放总数量 " prop="total_num">
                    <el-input v-model="form.total_num" placeholder="请输入发放总数量" type="number"></el-input>
                    <div class="tips">限制领取的优惠券数量，-1为不限制</div>
                </el-form-item>
                <el-form-item label="使用条件">
                    <el-radio-group v-model="form.free_limit">
                        <el-radio :label="0">不限制</el-radio>
                        <el-radio :label="1">不可与促销同时使用</el-radio>
                        <el-radio :label="2">不可与等级优惠同时使用</el-radio>
                        <el-radio :label="3">不可于促销和等级优惠同时使用</el-radio>
                    </el-radio-group>
                    <div class="tips">促销是指满减，等级优惠券值商品的会员等级折扣</div>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="form.sort" type="number" placeholder="请输入排序"></el-input>
                </el-form-item>
            </template>
            <template v-if="activeName == '2'">
                <div class="common-form">适用商品</div>
                <el-form-item label="选择">
                    <el-radio-group v-model="form.apply_range">
                        <el-radio :label="10">全部商品</el-radio>
                        <el-radio :label="20">
                            <span>指定商品</span>
                        </el-radio>
                        <el-radio :label="30">
                            <span>指定分类</span>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="form.apply_range == 20">
                    <el-button class="mb10" type="primary" plain @click="is_goods = true">添加商品 </el-button>
                    <el-table v-if="goods_list.length > 0" :data="goods_list" max-height="400" border style="width: 100%">
                        <el-table-column prop="goods_id" label="ID" width="180"> </el-table-column>
                        <el-table-column prop="goods_name" label="商品名称" width="180"> </el-table-column>
                        <el-table-column prop="image" label="图片">
                            <template slot-scope="scope">
                                <img v-img-url="hasImages(scope.row.goods_image)" alt="" width="50px" />
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="deleteClick(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item v-if="form.apply_range == 30" label="">
                    <el-button class="mb10" type="primary" plain @click="is_category = true">添加分类 </el-button>
                    <div>
                        <el-tag v-for="(item, index) in category_list.first" v-if="category_list.first.length > 0" :key="item.category_id" class=" mr10 mb10" type="info">
                            {{ item.parent ? item.parent + "→" + item.name : item.name }}
                        </el-tag>
                        <el-tag v-for="(item, index) in category_list.second" v-if="category_list.second.length > 0" :key="item.category_id" class=" mr10 mb10" type="info">
                            {{ item.parent ? item.parent + "→" + item.name : item.name }}
                        </el-tag>
                    </div>
                </el-form-item>
            </template>
            <!--提交-->
            <div class="common-button-wrapper">
                <el-button type="info" size="small" @click="cancelFunc">取消</el-button>
                <el-button type="primary" size="small" :loading="loading" @click="onSubmit">提交</el-button>
            </div>
        </el-form>
        <!--选择商品-->
        <Goods :isgoods="is_goods" :exclude-ids="exclude_ids" :islist="true" @closeDialog="closeGoodsFunc"></Goods>
        <Category :is_category="is_category" :exclude-ids="category_ids" @close="closeCategoryFunc"></Category>
    </div>
</template>

<script>
    import CouponApi from "@/api/coupon.js";
    import Goods from "@/components/goods/Goods.vue";
    import Category from "@/components/category/category.vue";
    export default {
        components: {
            Goods,
            Category
        },
        data() {
            const validateMinPrice = (rule, value, callback) => {
                if (parseFloat(value) <= this.form.reduce_price) {
                    callback(new Error('最低消费金额必须大于减免金额'));
                } else {
                    callback();
                }
            };
            const validateReducePrice = (rule, value, callback) => {
                if (parseFloat(value) > this.form.min_price) {
                    callback(new Error('最低消费金额必须大于减免金额'));
                } else {
                    callback();
                }
            };
            return {
                activeName: "1",
                /*form表单数据*/
                form: {
                    /*优惠券ID*/
                    coupon_id: "",
                    /*优惠券名称*/
                    name: "",
                    /*优惠券颜色*/
                    color: 10,
                    /*优惠券类型*/
                    coupon_type: 10,
                    /*减免金额*/
                    reduce_price: "",
                    /*折扣率*/
                    discount: "",
                    /*最低消费金额*/
                    min_price: "",
                    /*到期类型*/
                    expire_type: 10,
                    /*有效天数*/
                    expire_day: "",
                    /*有效期*/
                    active_time: "",
                    /*发放量*/
                    total_num: "",
                    /*排序*/
                    sort: 100,
                    /*优惠限制0不显示1不可与促销同时2不可与等级优惠同时3不可于促销和等级同*/
                    free_limit: 0,
                    apply_range: 10,
                    goods: []
                },
                rules: {
                    name: [
                        { required: true, message: '请输入优惠券名称', trigger: 'blur' }
                    ],
                    total_num: [
                        { required: true, message: '请输入发放量', trigger: 'blur' }
                    ],
                    min_price: [
                        { required: true, message: '请输入最低消费金额', trigger: 'blur' },
                        { validator: validateMinPrice, trigger: 'blur' }
                    ],
                    reduce_price: [
                        { required: true, message: '请输入减免金额', trigger: 'blur' },
                        { validator: validateReducePrice, trigger: 'blur' }
                    ]
                },
                loading: false,
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
                    }
                },
                prodcutData: [],
                isgoods: false,
                is_category: false,
                is_goods: false,
                exclude_ids: [],
                goods_list: [],
                category_list: {
                    second: [],
                    first: []
                },
                category_ids: []
            };
        },
        created() {},

        methods: {
            /*添加用户*/
            onSubmit() {
                let self = this;
                let form = self.form;
                form.goods_ids = self.exclude_ids;
                form.category_list = self.category_list;
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        // 如果是折扣，则判断折扣是否大于0小于10
                        if (form.coupon_type == 20) {
                            if (form.discount <= 0 || form.discount >= 10) {
                                self.$message({
                                    message: "折扣率介于0和10之间",
                                    type: "error"
                                });
                                return;
                            }
                        }else{
                            if(form.min_price*1<form.reduce_price*1){
                                self.$message({
                                    message: "最低消费金额必须大于减免金额",
                                    type: "error"
                                });
                                return;
                            }
                        }
                        self.loading = true;
                        CouponApi.addCoupon(form, true)
                            .then((data) => {
                                self.loading = false;
                                self.$message({
                                    message: "恭喜你，添加成功",
                                    type: "success"
                                });
                                self.$router.push("/coupon/coupon/index");
                            })
                            .catch((error) => {
                                self.loading = false;
                            });
                    }
                });
            },
            closeCategoryFunc(e) {
                let self = this;
                self.is_category = false;
                if (e) {
                    self.category_list = e;
                    console.log(e);
                }
            },
            /*关闭商品*/
            closeGoodsFunc(e) {
                let self = this;
                self.is_goods = e.openDialog;
                if (e.type == "success") {
                    e.params.forEach((item, index) => {
                        let params = {
                            goods_id: item.goods_id,
                            goods_name: item.goods_name,
                            goods_image: item.goods_image
                        };
                        self.exclude_ids.push(params.goods_id);
                        self.goods_list.push(params);
                    });
                }
            },
            deleteClick(e) {
                this.exclude_ids.splice(e, 1);
                this.goods_list.splice(e, 1);
            },
            hasImages(e) {
                if (e) {
                    return e;
                } else {
                    return "";
                }
            },
            /*取消*/
            cancelFunc() {
                this.$router.back();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .goods-add {
        padding-bottom: 50px;
    }

    .tips {
        color: #ccc;
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/views/coupon/coupon/add.vue